import { useMutation, useQueryClient, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface DeleteAdminAccountRequest {
    idx: number | string;
}

interface DeleteAdminAccountResponse {
    statusCode: number;
    message: string;
    data: null | string;
}

export const useDeleteConsoleAdminAccount = (): UseMutationResult<DeleteAdminAccountResponse, Error, DeleteAdminAccountRequest> => {
    const queryClient = useQueryClient();

    return useMutation<DeleteAdminAccountResponse, Error, DeleteAdminAccountRequest>({
        mutationFn: async ({ idx }) => {
            const url = enum_api_uri.delete_console_admin_account.replace(":idx", String(idx));
            const res = await axiosInstance.delete(url);
            return res.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleAdminAccounts"] });
        },
    });
};
